<section class="welcome">
  <div class="welcome__container">
    <h1 class="welcome__title dds-h1">
      Code of Ethics and Professional Conduct
    </h1>

    <p class="welcome__text">
      Our Shared Values are not an abstract ethical philosophy, but
      a powerful, living compass. They are intended to guide us all toward the right decisions and correct actions, in whatever
      situations we may encounter, whenever and wherever we are.
    </p>

    <app-search class="welcome__search"></app-search>

  </div>

  <div class="welcome-animation">
    @if (currentDevice === EDevices.desktop) {
    <div class="welcome-animation__container">
      <ng-lottie height="100%"
                 [options]="lottieOptions" />
    </div>
    }
  </div>

</section>
